import CodeBracketIcon from '@/assets/code-bracket.svg';
import DevicesIcon from '@/assets/devices.svg';
import GroupsIcon from '@/assets/groups.svg';
import ImportingIcon from '@/assets/import.svg';
import OrganisationsIcon from '@/assets/organisations.svg';
import PoliciesIcon from '@/assets/policies.svg';
import UsersIcon from '@/assets/users.svg';
import { urls } from '@/constants/urls';
import { NavItem } from '@/types/nav-item';

export const platformAdminNavItems: NavItem[] = [
  {
    title: 'Organisations',
    to: urls.organisations.base,
    Icon: OrganisationsIcon,
  },
  {
    title: 'Devices',
    to: urls.devices.base,
    Icon: DevicesIcon,
  },
  {
    title: 'Policies',
    to: urls.policies.base,
    Icon: PoliciesIcon,
  },
  {
    title: 'Users',
    to: urls.users.base,
    Icon: UsersIcon,
  },
  {
    title: 'Groups',
    to: urls.groups.base,
    Icon: GroupsIcon,
  },
  {
    title: 'Import Devices',
    to: urls.importing.base,
    Icon: ImportingIcon,
  },
  {
    title: 'Create API Credentials',
    to: urls.credentials.base,
    Icon: CodeBracketIcon,
  },
];
